type Color = `#${string}`;

type ColorPalette = [
  Color,
  Color,
  Color,
  Color,
  Color,
  Color,
  Color,
  Color,
  ...Color[],
];

type ColorPaletteName = (typeof COLOR_PALETTE_NAMES)[number];

const COLORS = {
  indigo: '#003399',
  blue: '#0077C0',
  aqua: '#03BFD7',
  green: '#87C879',
  lime: '#CAD844',
  red: '#ED1A3F',
  white: '#FFFFFF',
  lightGray: '#8C8C8C',
  gray: '#595959',
  darkGray: '#3C3C3C',
  black: '#000000',
  transparent: '#00000000',
} as const satisfies Record<string, Color>;

const COLOR_PALETTE_NAMES = [
  'vivid',
  'pale',
  'warm',
  'cool',
  'colorful',
  'red',
  'blue',
  'green',
] as const satisfies string[];

const COLOR_PALETTES = {
  vivid: [
    '#4C0035',
    '#650031',
    '#7F0024',
    '#98000A',
    '#B21800',
    '#CB4600',
    '#E57E00',
    '#FFC400',
  ],
  pale: [
    '#355C7D',
    '#626290',
    '#936693',
    '#BC6B86',
    '#D07A86',
    '#DF8B8A',
    '#ED9E8E',
    '#F8B195',
  ],
  warm: [
    '#FFFFB2',
    '#FED976',
    '#FEB24C',
    '#FD8D3C',
    '#F55735',
    '#F03B20',
    '#D71E23',
    '#BD0026',
  ],
  cool: [
    '#165E87',
    '#146E96',
    '#147FA4',
    '#0090AF',
    '#00A3AE',
    '#36B5A5',
    '#69C597',
    '#90D392',
  ],
  colorful: [
    '#69AF6D',
    '#9EBE5E',
    '#C3D151',
    '#E9E34E',
    '#F3CD46',
    '#E18C33',
    '#D35124',
    '#D90000',
  ],
  red: [
    '#FED9C6',
    '#FEBE9E',
    '#FD9B75',
    '#F56B52',
    '#EB3D2F',
    '#CB1C1E',
    '#A10E15',
    '#67000D',
  ],
  blue: [
    '#DEEBF7',
    '#C3DBEE',
    '#9CC8E2',
    '#6DAED5',
    '#4391C6',
    '#2271B4',
    '#0C5198',
    '#08306B',
  ],
  green: [
    '#E3F4DE',
    '#C6E8BF',
    '#A0D89B',
    '#73C378',
    '#45AA5D',
    '#228B45',
    '#06712D',
    '#00441B',
  ],
} as const satisfies Record<ColorPaletteName, ColorPalette>;

export type { Color, ColorPalette, ColorPaletteName };
export { COLORS, COLOR_PALETTES, COLOR_PALETTE_NAMES };
